import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setLanguage(language === "fr" ? "en" : "fr")}
      className="rounded-full font-mono text-xs px-3"
      aria-label="Toggle language"
    >
      {language === "fr" ? "EN" : "FR"}
    </Button>
  );
};

export default LanguageToggle;
